import { useEffect, useRef, useState } from "react"

import { useAppSelector } from "store/hooks"
import { userLogoSelector } from "store/tempDataSlise"
import styles from "assets/scss/index.module.scss"
import logo from "assets/svg/logo-white.svg"

import { useRefreshUserProfile } from "hooks/useRefreshUserProfile"

import { LogoWrapper as StyledLogoWrapper, StyledLogo } from "../styled"

export const LogoWrapper = () => {
  const userLogo = useAppSelector(userLogoSelector)
  const refreshProfile = useRefreshUserProfile()
  const hasRetried = useRef(false)
  const [hasFallenBack, setHasFallenBack] = useState(false)

  useEffect(() => {
    hasRetried.current = false
    setHasFallenBack(false)
  }, [userLogo])

  const handleError = () => {
    if (!userLogo) return

    if (!hasRetried.current) {
      hasRetried.current = true
      refreshProfile()
    } else {
      setHasFallenBack(true)
    }
  }

  const src = !userLogo || hasFallenBack ? logo : `${userLogo}?cors=logo`

  return (
    <StyledLogoWrapper className={styles.logoWrapper} to="/">
      <StyledLogo className={styles.logo} src={src} onError={handleError} alt="logo" />
    </StyledLogoWrapper>
  )
}
